import React, { useEffect, useState } from "react";

// custom components
import Button from "../../Subcomponents/Button";
import ProgressCard from "../../Subcomponents/ProgressCard";
import { errorTost, successTost } from "../../Services/Toast";
import TabsMenu from "../../Subcomponents/TabsMenu";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import SelectPreRequisite from "../../Components/SelectPreRequisite/SelectPreRequisite";
import CustomToggle from "../../Subcomponents/Toggle/CustomToggle";
import DropDown from "./../../Subcomponents/DropDown";

// css
import cssClasses from "./selectTokens.module.css";

// assets
import selectTokenImg from "../../Assets/Images/Common/selectToken.svg";

// mui
import { Box, Checkbox } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import CustomRadio from "../../Subcomponents/CustomRadio";
import Datagrid from "../../Subcomponents/Datagrid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SelectToken from "../../Components/SelectToken/SelectToken";
import ScheduleToken from "../../Components/scheduleToken/ScheduleToken";
import DateComponent from "../../Subcomponents/DateComponent";
import { getAllTokens } from "../../Services/Tokens";
import { cloneDeep, differenceWith, groupBy, isEqual, sortBy, uniq, uniqBy } from "lodash";
import { checkTagLaunchesData, deleteEventTokens, deleteTagLaunches, editTagLaunches, getAllEventTokens, insertEventTokens, insertTagLaunches, updateEventTokens } from "../../Services/EventTokens";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getEvent, getLaunches, updateEvent } from "../../Services/Event";
import SelectRepeatedEvent from "../../Subcomponents/SelectRepeatedEvent/SelectRepeatedEvent";
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import { getAllLaunchesByEvent } from "../../Services/Launch";
import { deleteInventoryRelationsOfPreselect, getInventoryMerge, getLaunchInventory, getLaunchInventoryForPreselect, getPreselectInventory, insertIntoPreselectInventoryRelations, updateInventoryRelations } from "../../Services/Inventory";
import SelectInventory from "../../Components/SelectInventory/SelectInventory";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { supabase } from "../../supabaseClient";
import CustomInput from "../../Subcomponents/CustomInput";
import TagLaunch from "../../Components/TagLaunch/TagLaunch";
import MultiSelectDropDown from "../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown";
import { useSelector } from "react-redux";

function SelectTokens() {
  const params = useParams()
  const navigate = useNavigate()
  const loggedInUser = useSelector((state) => state.Auth.user);
  const eventId = params.eventId
  const [searchParams, setSearchParams] = useSearchParams();
  const submenu = searchParams.get('submenu');
  const dispatch = useDispatch();
  const [openAlert, setOpenAlert] = useState(false);
  const [showPPConfig, setShowPPConfig] = useState(false);
  const [openEventAlert, setOpenEventAlert] = useState(false);
  const [openPrerequisiteAlert, setOpenPrerequisiteAlert] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchToken, setSearchToken] = useState('')
  const [repeatedEventId, setRepeatedEventId] = useState(null)
  const [tokenForPP, setTokenForPP] = useState(null)
  const [allTokens, setAllTokens] = useState([])
  const [allChildTokens, setAllChildTokens] = useState([])
  const [clickedIndex, setClickedIndex] = useState(0)
  const [isRepeated, setIsRepeated] = useState(false)
  const [showInventory, setShowInventory] = useState(false)
  const [allLaunches, setAllLaunches] = useState([])
  const [allInventory, setAllInventory] = useState([])
  const [unitsToMerge, setUnitsToMerge] = useState([])
  const [allUnitsToMerge, setAllUnitsToMerge] = useState([])
  const [allChildInventory, setAllChildInventory] = useState([])
  const [selectedLaunch, setSelectedLaunch] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedToken, setSelectedToken] = useState(null)
  const [totalFloorsSelected, setTotalFloorsSelected] = useState(0)
  const [totalUnitsSelected, setTotalUnitsSelected] = useState(0)
  const [helperText, setHelperText] = useState({ limit: '', paymentTimer: '' })
  const selectTokenGridColumns = [
    {
      field: "name",
      headerName: "Token Name",
      width: 500,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.isSelected}
                onChange={(e) => {
                  setAllChildTokens((pre) => {
                    pre[pre.findIndex((e) => e.id === params.row.id)].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)]
                        .isSelected;
                    return [...pre];
                  });
                }}
              />
            </div>
            <div>
              <p>{params.row.name}</p>
            </div>
          </div>
        );
      },
    },
   
    {
      field: "tokentype",
      headerName: "Token Type",
      width: 300,
      renderCell: (params) => {
        return (
          <>
            {params.row.isPriorityPass === true
              ? 'Priority Pass'
              : params.row.isPreselect === true
              ? 'Preselect'
              : params.row.isPreselect === false &&
                params.row.isPriorityPass === false
              ? 'None'
              : ''}
          </>
        )
      }
    },
    // {
    //   field: "isPreselect",
    //   headerName: "Preselect",
    //   width: 300,
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         {params.row.isPreselect === true ?
    //           <p>Yes</p>
    //           :
    //           <p>No</p>
    //         }
    //       </>
    //     )
    //   }
    // },
    {
      field: "amount",
      headerName: "Amount",
      width: 200,
    },
  ];
  const [event, setEvent] = useState(null)
  const optionList = ["Yes", "No"];
  const [selectTokens, setSelectTokens] = useState({
    title: "Select Tokens",
    totalProgress: 4,
    currentProgress: 0,
    timeline: [
      { text: "Repeated Launch", value: "Repeated Launch", isSelected: true },
      {
        text: "Select Token",
        value: "Select Token",
        isSelected: false,
      },
      { text: "Select Prerequisite", value: "Select Prerequisite", isSelected: false },
      { text: "Schedule Token", value: "Schedule Token", isSelected: false },
      { text: "Tag Launch", value: "Tag Launch", isSelected: false },
    ],
    image: selectTokenImg,
  });
  const [preselect, setPreselect] = useState([
    {
      value: 'Select Inventory',
      text: 'Select Inventory',
      isSelected: true
    },
    // {
    //   value: 'Update Price',
    //   text: 'Update Price',
    //   isSelected: true
    // }
  ])
  const handleChange = (value) => {
    if (value === 'Yes') {
      setOpenModal(true)
      setIsRepeated(true)
    } else {
      setOpenModal(false)
      setIsRepeated(false)
    }
  };
  const handleTagLaunchChange=(e,para)=>{
    const value = e?.target?.value;
    const idCount = value.reduce((acc, item) => {
      acc[item.id] = (acc[item.id] || 0) + 1;
      return acc;
    }, {});
    
    const filteredValue = value.filter((item, index, self) =>
      self.findIndex((t) => t.id === item.id) === index && idCount[item.id] % 2 !== 0
    );
    const typeList = allLaunches?.map(v => {
      return {
        label: v?.title,
        name: v?.title,
        id:v?.launchId
      }
    })
    const index = allChildTokens?.findIndex(i => i?.id === para?.row?.id);
    const payload=[...allChildTokens];
    
    if (filteredValue !== '') {
      if (filteredValue[filteredValue.length - 1] === 'all') {
         const dataLaunch = [...allChildTokens]
         dataLaunch[index].launches =[]
        setAllChildTokens(
          para?.row?.launches?.length ===
            typeList?.length
            ? dataLaunch
            : payload?.map((v,index1) => {
              if(index === index1){
                v.launches = typeList}
                return v;
            })
        );
      }else{
          payload[index].launches =  filteredValue 
          setAllChildTokens(payload);
        }
    }
  }
  const selectPreRequisiteGridColumns = [
    {
      field: 'action',
      headerName: 'Preselect',
      width: '100',
      renderCell: (params) => {
        return (
          <div>
            {params.row.isPreselect ?
              <ThreeDotsMenu list={['Select Inventory']} selectedValue={(e) => { setShowInventory(true); getLaunches(); setSelectedLaunch(null); setSelectedToken(params.row.eventTokenId) }} />
              :
              <p style={{ paddingLeft: '2rem' }}>NA</p>
            }
          </div>
        )
      }
    },
    {
      field: 'action1',
      headerName: 'Priority Pass',
      width: '100',
      renderCell: (params) => {
        return (
          <div>
            {params.row.isPriorityPass ?
              <ThreeDotsMenu list={['Configure']} selectedValue={(e) => { setTokenForPP(params.row) }} />
              :
              <p style={{ paddingLeft: '2rem' }}>NA</p>
            }
          </div>
        )
      }
    },
    {
      field: "name",
      headerName: "Token Name",
      width: 500,
      renderCell: (params, index) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>{params.row.index}. </div>
            <div>
              <p>{params.row.name}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: "selectPreRequisite",
      headerName: "Select Prerequisite",
      width: 300,

      renderCell: (params) => {
        return (
          <div>
            {allChildTokens.filter((e) => {
              if (e.isSelected === true && e.eventTokenId !== params.row.eventTokenId && e.eventPrerequisiteName !== params.row.name) {
                return true
              } else {
                return false
              }
            }).length > 0 ?
              (
                < CustomToggle
                  checked={params.row.isPrerequisite === true}
                  setChecked={() => {
                    setAllChildTokens((pre) => {
                      if (pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].isPrerequisite) {
                        pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].eventPrerequisiteName = null
                      }
                      pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].isPrerequisite = !pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].isPrerequisite;
                      return [...pre]
                    })
                  }}
                />
              )
              :
              (
                "NA"
              )
            }
          </div>
        );
      },
    },
    {
      field: "selectPrerequisiteArray",
      headerName: "Select Prerequisite ",
      width: 450,
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // gap: "15rem",
            }}
          >
            <div>
              <p>
                {(params.row.isPrerequisite && allChildTokens.filter((e) => {
                  if (e.isSelected === true && e.eventTokenId !== params.row.eventTokenId && e.eventPrerequisiteName !== params.row.name) {
                    return true
                  } else {
                    return false
                  }
                }).length > 0) ? (
                  <DropDown
                    list={allChildTokens.filter((e) => {
                      if (e.isSelected === true && e.eventTokenId !== params.row.eventTokenId && e.eventPrerequisiteName !== params.row.name) {
                        return true
                      } else {
                        return false
                      }
                    })}
                    style={{
                      selectedColor: "#175CD3",
                      background: "#E8F0FE",
                    }}
                    selectedValue={allChildTokens.filter((e) => { return e.name === params.row.eventPrerequisiteName })[0]}
                    onChangeSelect={(e) => {
                      console.log(e);
                      setAllChildTokens((pre) => {
                        pre[pre.findIndex((ele) => (ele.eventTokenId === params.row.eventTokenId))].eventPrerequisiteName = e.name;
                        return [...pre]
                      })
                      // setToken({ ...token, validity: e });
                    }}
                  />
                ) : (
                  "NA"
                )}
              </p>
            </div>
            {/* <div
              style={{
                textAlign: "center",
              }}
            >
              <MoreVertIcon sx={{ fontSize: "2rem", cursor: "pointer" }} />
            </div> */}
          </div>
        );
      },
    }
  ];

  const TagLaunchColumn= [
    {
      field: "name",
      headerName: "Token Name",
      width: 500,
      renderCell: (params, index) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>{params.row.index}. </div>
            <div>
              <p>{params.row.name}</p>
            </div>
          </div>
        );
      },
    },
    // {
    //   field: "tagLaunch",
    //   headerName: "Tag Launch",
    //   width: 300,

    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         {allChildTokens.filter((e) => {
    //           if (e.isSelected === true && e.eventTokenId !== params.row.eventTokenId) {
    //             return true
    //           } else {
    //             return false
    //           }
    //         }).length > 0 ?
    //           (
    //             < CustomToggle
    //               checked={params.row?.isTagLaunch === true}
    //               setChecked={() => {
    //                 setAllChildTokens((pre) => {
    //                   pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].isTagLaunch = !pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))]?.isTagLaunch;
    //                   return [...pre]
    //                 })
    //               }}
    //             />
    //           )
    //           :
    //           (
    //             "NA"
    //           )
    //         }
    //       </div>
    //     );
    //   },
    // },
    {
      field: "tagLaunchArray",
      headerName: "Tag Launch",
      width: 450,
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // gap: "15rem",
            }}
          >
            <div>
              <p>
                {(allChildTokens.filter((e) => {
                  if (e.isSelected === true && e.eventTokenId !== params.row.eventTokenId) {
                    return true
                  } else {
                    return false
                  }
                }).length > 0) ? (
                  <MultiSelectDropDown
                                list={allLaunches?.map(v => {
                                  return {
                                    ...v,
                                    label: v?.title,
                                    name: v?.title,
                                    id:v?.launchId
                                  }
                                })}
                                value={allChildTokens?.filter(v => v?.id === params?.id)[0]?.launches}
                                placeHolder="Search by Type"
                                ReportDropDown={false}
                                handleChange={(e) => {
                                  handleTagLaunchChange(e,params);
                                }}
                              />
                ) : (
                  "NA"
                )}
              </p>
            </div>
          </div>
        );
      },
    }
  ];
  useEffect(() => {
    console.log('tokenForPP: ', tokenForPP);
    if (tokenForPP) {
      setShowPPConfig(true)
    }
  }, [tokenForPP])

  const scheduleTokenGridColumns = [
    {
      field: "name",
      headerName: "Token Name",
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>{params.row.index}. </div>
            <div>
              <p>{params.row.name}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: "startDateTime",
      headerName: "Start Date And Time",
      width: 300,

      renderCell: (params) => {
        return (
          <div>
            <DateComponent
              // helperText={!params.row.startDateTime ? 'Please start date & time' : ''}
              helperText={''}
              minDate={new Date(event?.startDateTime).setMonth(new Date(event?.startDateTime).getMonth() - 6)}
              maxDate={allChildTokens[allChildTokens.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime ? allChildTokens[allChildTokens.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime : event?.startDateTime}
              disabled={params.row.isPriorityPass ? true : false}
              onChangeDate={(e) => {
                setAllChildTokens((pre) => {
                  if (e !== '' && pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime && pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime !== '' && pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime <= e) {
                    errorTost("Please select date and time which is less than end date time")
                    pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].startDateTime = '';
                    return [...pre]
                  } else {
                    pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].startDateTime = e;
                    return [...pre]
                  }
                })
              }}
              value={params.row.startDateTime}
            />
          </div>
        );
      },
    },
    {
      field: "endDateTime",
      headerName: "End Date And Time",
      width: 300,
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // gap: "15rem",
            }}
          >
            <DateComponent
              // disabled={event.startDateTime === ""}
              disabled={params.row.isPriorityPass ? true : false}
              minDate={params.row.startDateTime ? params.row.startDateTime : 
                new Date(event?.startDateTime).setMonth(new Date(event?.startDateTime).getMonth() - 6)}
              // maxDate={event?.startDateTime}
              helperText={''}
              // label={"End Date Time"}
              onChangeDate={(e) => {
                setAllChildTokens((pre) => {
                  if (e !== '' && pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].startDateTime !== '' && pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].startDateTime >= e) {
                    errorTost("Please select date and time which is greater than start date time")
                    pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime = '';
                    return [...pre]
                  } else {
                    pre[pre.findIndex((e) => (e.eventTokenId === params.row.eventTokenId))].endDateTime = e;
                    return [...pre]
                  }
                })
              }}
              value={params.row.endDateTime}
            />

            <div
              style={{
                textAlign: "center",
              }}
            >
              {/* <MoreVertIcon sx={{ fontSize: "2rem", cursor: "pointer" }} /> */}
            </div>
          </div>
        );
      },
    },
  ];

  function copyConfig(id) {
    if (allTokens.filter((e) => { return e.isSelected === true }).length > 0) {
      setOpenEventAlert(true)
    } else {
      getData(id, true)
    }
  }

  function getLaunches() {
    getAllLaunchesByEvent(eventId).then((launches) => {
      if (launches.data.length > 0) {
        console.log(launches.data)
        setAllLaunches(launches.data)
      }
    })
  }

  useEffect(() => {
    if (selectedLaunch && selectedLaunch !== '') {
      getLaunchInventory(selectedLaunch).then((resp) => {
        // getAllInventory(launch.projectId).then((resp) => {
        let array = []
        resp.forEach((ele) => {
          array.push(ele.unitId)
        })
        // if (launch?.pricing?.plc?.length === 0) {
        //     let views = groupBy(resp, 'view')
        //     setLaunch((pre) => { pre.pricing.plc = []; return { ...pre } })
        //     setChildLaunch((pre) => { pre.pricing.plc = []; return { ...pre } })
        //     Object.keys(views).forEach((e) => {
        //         setLaunch((pre) => {
        //             pre.pricing.plc.push({
        //                 name: e,
        //                 value: null,
        //                 type: ''
        //             })
        //             return { ...pre }
        //         })
        //         setChildLaunch((pre) => {
        //             pre.pricing.plc.push({
        //                 name: e,
        //                 value: null,
        //                 type: ''
        //             })
        //             return { ...pre }
        //         })
        //     })
        // }
        getPreselectInventory(selectedToken, selectedLaunch).then((res) => {
          getInventoryMerge(selectedProject).then((merge) => {
            setAllUnitsToMerge([...merge])
            let arr = cloneDeep([...merge])
            setUnitsToMerge([...arr])
          })
          if (res.length > 0) {
            array.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.isSelected = false; ele.showCheckbox = true; ele.launchId = selectedLaunch; ele.show = true })
            array = groupBy(array, 'wingName')
            Object.keys(array).forEach((ele) => {
              array[ele] = {
                isSelected: false,
                floors: groupBy(array[ele], 'floorNo')
              }
              Object.keys(array[ele].floors).forEach((e) => {
                array[ele].floors[e] = {
                  isSelected: false,
                  units: sortBy(array[ele].floors[e], 'unitNo')
                }
              })
            })
            console.log("res" , res)
            res.forEach((el) => {
              array[el.wingId.wingName].floors[el.unitId.floorNo].units[array[el.wingId.wingName].floors[el.unitId.floorNo].units.findIndex((e) => e.unitId === el.unitId.unitId)].isSelected = true
              // if (array[el.wingId.wingName].floors[el.unitId.floorNo].units.length === array[el.wingId.wingName].floors[el.unitId.floorNo].units.filter((e) => e.isSelected === true).length) {
              if (array[el.wingId.wingName].floors[el.unitId.floorNo].units.filter((e) => e.isSelected === true).length > 0) {
                array[el.wingId.wingName].floors[el.unitId.floorNo].isSelected = true
              }
              // if (Object.keys(array[el.wingId.wingName].floors).length === Object.keys(array[el.wingId.wingName].floors).filter((e) => { return array[el.wingId.wingName].floors[e].isSelected === true }).length) {
              if (Object.keys(array[el.wingId.wingName].floors).filter((e) => { return array[el.wingId.wingName].floors[e].isSelected === true }).length > 0) {
                array[el.wingId.wingName].isSelected = true
              }
            })
            let newarr = cloneDeep(array)
            setAllInventory(newarr)
            setAllChildInventory(array)
          } else {
            let allunits = cloneDeep(array)
            allunits.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.isSelected = false; ele.showCheckbox = false; ele.launchId = selectedLaunch })
            allunits = groupBy(allunits, 'wingName')
            Object.keys(allunits).forEach((ele) => {
              allunits[ele] = {
                isSelected: false,
                floors: groupBy(allunits[ele], 'floorNo')
              }
              Object.keys(allunits[ele].floors).forEach((e) => {
                allunits[ele].floors[e] = {
                  isSelected: false,
                  units: sortBy(allunits[ele].floors[e], 'unitNo')
                }
              })
            })
            let newarr1 = cloneDeep(allunits)
            setAllInventory(newarr1)
            array.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.isSelected = true; ele.showCheckbox = true; ele.launchId = selectedLaunch; ele.show = true })
            array = groupBy(array, 'wingName')
            Object.keys(array).forEach((ele) => {
              array[ele] = {
                isSelected: true,
                floors: groupBy(array[ele], 'floorNo')
              }
              Object.keys(array[ele].floors).forEach((e) => {
                array[ele].floors[e] = {
                  isSelected: true,
                  units: sortBy(array[ele].floors[e], 'unitNo')
                }
              })
            })
            let newarr = cloneDeep(array)
            // setAllInventory(newarr)
            setAllChildInventory(newarr)
          }
        })
      }).catch((err) => {
      })
    }
  }, [selectedLaunch])

  useEffect(() => {
    tabChanged('', submenu)
    getLaunches()
  }, [submenu])

  useEffect(() => {
    // if (!selectTokens.timeline[0].isSelected === true) {
    if (allTokens.length === 0 && !repeatedEventId?.clone) {
      getData(eventId)
    } else {
      if (searchToken === '') {
        allChildTokens.forEach((e, index) => { setAllChildTokens((pre) => { pre[index].show = true; return [...pre] }) })
        allTokens.forEach((e, index) => { setAllTokens((pre) => { pre[index].show = true; return [...pre] }) })
      } else {
        allTokens.forEach((ele) => {
          if (!ele.name.toUpperCase().includes(searchToken.toUpperCase())) {
            setAllChildTokens((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = false; return [...pre] })
            setAllTokens((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = false; return [...pre] })
          } else {
            setAllChildTokens((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = true; return [...pre] })
            setAllTokens((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = true; return [...pre] })
          }
        })
        setAllChildTokens(sortBy(allChildTokens, [function (o) { return !o.isSelected }]))
      }
    }
    // }
  }, [searchToken, selectTokens])

  function getData(eventId, repeated = false) {
    presentLoader()
    getAllTokens().then((resp) => {
      resp.data.forEach((ele, index) => { ele.eventPrerequisiteName = null; ele.label = ele.name; ele.id = ele.tokenId; ele.show = true; ele.index = index; ele.isSelected = false; ele.isPrerequisite = false })
      getAllEventTokens(eventId).then((res) => {
        getAllLaunchesByEvent(eventId).then((launches) => {
          resp.data = resp?.data?.map((v) => {
                  return {
                    ...v,
                    launches: launches?.data?.map((d) => {
                      return {
                        ...d,
                        label: d?.title,
                        name: d?.title,
                        id: d?.launchId,
                      };
                    }),
                  };
            })
        if (res.data.length > 0) {
          res.data.forEach((ele, index) => {
           // checkTagLaunchesData(eventId,ele?.eventTokenId).then((value) => {
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].isEdit = ele?.EventTokensLaunchRelations?.length > 0 ? true : false
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].launches = ele?.EventTokensLaunchRelations?.length > 0 ? ele?.EventTokensLaunchRelations?.map(e => {return {
              ...e?.launchId,
              label: e?.launchId?.title,
              name: e?.launchId?.title,
              id: e?.launchId?.launchId,
            }}) : [];
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].isSelected = true
            if (!repeated) {
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].startDateTime = ele.startDateTime
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].endDateTime = ele.endDateTime
            } else {
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].startDateTime = null
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].endDateTime = null
            }
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].eventTokenId = ele.eventTokenId
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].startTimerFrom = ele.startTimerFrom
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].startPaymentFrom = ele.startPaymentFrom
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].expirePaymentOn = ele.expirePaymentOn
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].limit = ele.limit
            resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].paymentTimer = ele.paymentTimer
            if (ele.prerequisiteId && ele.prerequisiteId !== '') {
              console.log("hello")
              console.log(res.data.findIndex((e) => e.eventTokenId === ele.eventPrerequisiteId))
              // console.log(res.data.map((m)=>()))
              // console.log(res.data[res.data.findIndex((e) => e.eventTokenId === ele.eventPrerequisiteId)].tokenId.name)
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].isPrerequisite = true
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].prerequisiteId = ele.prerequisiteId
              resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].eventPrerequisiteName = ele.prerequisiteId.tokenId.name
              // resp.data[resp.data.findIndex((e) => e.tokenId === ele.tokenId.tokenId)].eventPrerequisiteName = res.data[res.data.findIndex((e) => e.eventTokenId === ele.eventPrerequisiteId)].tokenId.name
            }
            resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
            let newarr = cloneDeep(resp.data)
            if (index === res.data.length - 1) {
              res.data.forEach((ele, index) => {

              })
              // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
              setAllChildTokens([...resp.data])
              if (!repeated) {
                setAllTokens([...newarr])
              }
              if (selectTokens.timeline[0].isSelected && repeated) {
                setSelectTokens((pre) => { pre.timeline[1].isSelected = true; pre.timeline[0].isSelected = false; return { ...pre } })
                setOpenEventAlert(false)
              }
              setOpenEventAlert(false)
            }
          })
          //})
          dismissLoader()
        } else {
          let newarr = cloneDeep(resp.data)
          setAllChildTokens([...resp.data])
          setAllTokens([...newarr])
          dismissLoader()
          // setSelectTokens((pre) => { pre.timeline[1].isSelected = true; pre.timeline[0].isSelected = false; return { ...pre } })
        }
    })
      }).catch((err) => {
        let newarr = cloneDeep(resp.data); setAllChildTokens([...resp.data]); setAllTokens([...newarr])
        dismissLoader()
      })
    }).catch((err) => {
      dismissLoader()
    })
  }


  useEffect(() => {
    dispatch(action.activeMenu("ConfigureEvent"));
    getEvent(eventId).then((resp) => {
      console.log(resp[0])
      resp[0].tokenCompletedTabs = resp[0].tokenCompletedTabs ? resp[0].tokenCompletedTabs : []
      setEvent(resp[0])
      setIsRepeated(resp[0].isTokensRepeated)
      if (resp[0].isTokensRepeated) {
        setRepeatedEventId({ repeatedEventId: resp[0].tokensRepeatedEventId.eventId, repeatedEventName: resp[0].tokensRepeatedEventId.title })
      }
    })

  }, [])

  useEffect(() => {
    console.log(allChildInventory)
    let totalFloorsCount = 0
    let totalUnitsCount = 0
    Object.keys(allChildInventory).forEach((wing) => {
      Object.keys(allChildInventory[wing]).forEach((floor) => {
        totalFloorsCount = totalFloorsCount + Object.keys(allChildInventory[wing][floor]).filter((element) => {
          totalUnitsCount = totalUnitsCount + allChildInventory[wing][floor][element].units.filter((unit) => { return unit.isSelected === true }).length
          return allChildInventory[wing][floor][element].isSelected === true
        }).length
        setTotalFloorsSelected(totalFloorsCount)
        setTotalUnitsSelected(totalUnitsCount)
      })
    })
  }, [allChildInventory])

  useEffect(() => {
    setSelectTokens((pre) => {
      pre.currentProgress = event?.tokenCompletedTabs.length
      pre.timeline.forEach((ele) => {
        if (event?.tokenCompletedTabs.includes(ele.text)) {
          ele.isCompleted = true
        }
      })
      return { ...pre }
    })
  }, [event])

  function tabChanged(e, value) {
    let index = selectTokens.timeline.findIndex((e) => e.value === value);
    if (allTokens.filter((ele) => { return ele.isSelected === true }).length === 0 && index > 1) {
      if (document.getElementById("input-with-icon-textfieldabc"))
        document.getElementById("input-with-icon-textfieldabc").value = ''
      errorTost("Please add tokens to proceed");
      searchParams.set('submenu', 'Select Token')
      setSearchParams(searchParams)
    } else {
      if (selectTokens.timeline[0].isSelected === true) {
        setSelectTokens((pre) => {
          pre.timeline[0].isSelected = false;
          pre.timeline[index].isSelected = true;
          return { ...pre };
        });
      } else if (selectTokens.timeline[1].isSelected === true) {
        if (!isEqual(allChildTokens, allTokens) && index !== 1) {
          setClickedIndex(index)
          setOpenAlert(true)
          // searchParams.set('submenu', 'Select Token')
          // setSearchParams(searchParams)
        } else {
          if (index !== 1) {
            setSearchToken('')
          }
          setSelectTokens((pre) => { pre.timeline[1].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
        }
      } else if (selectTokens.timeline[2].isSelected === true) {
        if (showInventory) {
          console.log(allChildInventory)
          console.log(allInventory)
          if (!isEqual(allChildInventory, allInventory) && index !== 2) {
            setClickedIndex(index)
            setOpenAlert(true)
          } else {
            setShowInventory(false)
            setSelectTokens((pre) => { pre.timeline[2].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
          }
        } else {
          if (!isEqual(allChildTokens, allTokens) && index !== 2) {
            setClickedIndex(index)
            setOpenAlert(true)
            // searchParams.set('submenu', 'Select Prerequisite')
            // setSearchParams(searchParams)
          } else {
            if (index !== 2) {
              setSearchToken('')
            }
            setSelectTokens((pre) => { pre.timeline[2].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
          }
        }
      } else if (selectTokens.timeline[3].isSelected === true) {
        if (!isEqual(allChildTokens, allTokens) && index !== 3) {
          setClickedIndex(index)
          setOpenAlert(true)
          // searchParams.set('submenu', 'Schedule Token')
          // setSearchParams(searchParams)
        } else {
          if (index !== 3) {
            setSearchToken('')
          }
          setSelectTokens((pre) => { pre.timeline[3].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
        }
      } else {
        setSelectTokens((pre) => {
          pre.timeline[
            selectTokens.timeline.findIndex((e) => e.isSelected === true)
          ].isSelected = false;
          pre.timeline[index].isSelected = true;
          return { ...pre };
        });
      }
    }
    // }
  }

  function ModalResp(e) {
    setOpenAlert(false)
    let index = selectTokens.timeline.findIndex((e) => e.isSelected === true)
    if (e === 'confirmed') {
      setSearchToken('')
      searchParams.set('submenu', selectTokens.timeline[clickedIndex].value)
      setSearchParams(searchParams)
      if (index === 1) {
        setRepeatedEventId(null)
        setIsRepeated(false)
        setSelectTokens((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[1].isSelected = false; return { ...pre } })
        allTokens.forEach((e, index) => {
          setAllTokens((pre) => {
            pre[index].show = true;
            return [...pre]
          })
        })
        let arr = cloneDeep(allTokens)
        setAllChildTokens(arr)
      } else if (index === 2) {
        if (showInventory) {
          setSelectTokens((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
          setShowInventory(false)
        } else {
          setSelectTokens((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
          allTokens.forEach((e, index) => {
            setAllTokens((pre) => {
              pre[index].show = true;
              return [...pre]
            })
          })
          let arr = cloneDeep(allTokens)
          setAllChildTokens(arr)
        }
      } else if (index === 3) {
        setSelectTokens((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
        allTokens.forEach((e, index) => {
          setAllTokens((pre) => {
            pre[index].show = true;
            return [...pre]
          })
        })
        let arr = cloneDeep(allTokens)
        setAllChildTokens(arr)
      } else if (index === 4) {

      } else if (index === 5) {

      }
    } else {
      // if (!showInventory) {
      searchParams.set('submenu', selectTokens.timeline[index].value)
      setSearchParams(searchParams)
      // }
    }
  }

  async function Overwrite(e) {
    if (e === 'confirmed') {
      // console.log(allTokens.filter((e) => { return e.eventTokenId && e.eventTokenId !== '' }))
      console.log(allTokens.filter((e) => { return e.isSelected === true }))
      // let arr = cloneDeep(sortBy(allTokens.filter((e) => { return e.eventTokenId && e.eventTokenId !== '' }), 'eventPrerequisiteName'))
      // let arr = cloneDeep(allTokens.filter((e) => { return e.eventTokenId && e.eventTokenId !== '' }))
      let arr = cloneDeep(allTokens.filter((e) => { return e.isSelected === true }))
      // sortBy(allTokens.filter((e) => { return e.eventTokenId && e.eventTokenId !== '' }), 'eventPrerequisiteName').forEach((ele, index) => {
      arr.forEach((ele, index) => {
        deleteEventTokens(ele.eventTokenId).then((resp) => {
          if (arr.length - 1 === index) {
            updateEvent(eventId, { tokenCompletedTabs: null, isTokensRepeated: false, tokensRepeatedEventId: null }).then((resp) => {
              setEvent((pre) => {
                pre.tokenCompletedTabs = [];
                return { ...pre }
              })
              let array = cloneDeep(allTokens)
              array.forEach((ele, index) => {
                ele.isSelected = false
                if (array.length - 1 === index) {
                  setAllTokens([...array])
                }
              })
              getData(repeatedEventId.repeatedEventId, true)
            })
          }
        }).catch((err) => {
          if (arr.length - 1 === index) {
            updateEvent(eventId, { tokenCompletedTabs: null, isTokensRepeated: false, tokensRepeatedEventId: null }).then((resp) => {
              setEvent((pre) => {
                pre.tokenCompletedTabs = [];
                return { ...pre }
              })
              let array = cloneDeep(allTokens)
              array.forEach((ele, index) => {
                ele.isSelected = false
                if (array.length - 1 === index) {
                  setAllTokens([...array])
                }
              })
              getData(repeatedEventId.repeatedEventId, true)
            })
          }
        })
      })
    } else {
      setOpenEventAlert(false)
      setRepeatedEventId(null)
      setIsRepeated(false)
    }
  }

  function ChangeTab(e) {
    if (e === 'confirmed') {
      setSelectTokens((pre) => {
        pre.timeline[1].isSelected = false;
        pre.timeline[2].isSelected = true;
        return { ...pre }
      })
      let arr = cloneDeep([...allTokens])
      setAllChildTokens([...arr])
      setOpenPrerequisiteAlert(false)
    } else {
      let arr = cloneDeep([...allTokens])
      setAllChildTokens([...arr])
      setOpenPrerequisiteAlert(false)
    }
  }

  async function nextStep() {
    if (
      selectTokens.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Select Token"
    ) {
      let allExistingCp = allTokens.filter((e) => {
        return e.isSelected === true;
      });
      let arr = allChildTokens.filter((e) => {
        return e.isSelected === true;
      });
      if (arr.length === 0) {
        let newarr = cloneDeep(allTokens);
        setAllChildTokens([...newarr]);
        errorTost("Please select atleast one token and then save");
        searchParams.set("submenu", "Select Token");
        setSearchParams(searchParams);
      } else {
        presentLoader();
        if (allExistingCp.length > 0) {
          let insertarr = differenceWith(arr, allExistingCp, isEqual);
          let deletearr = differenceWith(allExistingCp, arr, isEqual);
          if (insertarr.length > 0) {
            insertarr.forEach((element, index) => {
              insertEventTokens({
                tokenId: element.tokenId,
                eventId: eventId,
              }).then((resp) => {
                console.log(resp);
                setAllTokens((pre) => {
                  pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].isSelected = true;
                    pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].launches = [];
                  pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].eventTokenId = resp.data[0].eventTokenId;
                  return [...pre];
                });
                setAllChildTokens((pre) => {
                  pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].isSelected = true;
                  pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].launches = [];
                  pre[
                    pre.findIndex((e) => e.tokenId === element.tokenId)
                  ].eventTokenId = resp.data[0].eventTokenId;
                  return [...pre];
                });
                if (index === insertarr.length - 1) {
                  if (!event.tokenCompletedTabs.includes("Select Token")) {
                    let obj = cloneDeep(event);
                    obj.tokenCompletedTabs.push("Select Token");
                    if (isRepeated === true) {
                      obj.tokensRepeatedEventId =
                        repeatedEventId.repeatedEventId;
                      obj.isTokensRepeated = isRepeated;
                    }
                    updateEvent(eventId, obj).then((resp) => {
                      setEvent((pre) => {
                        pre.tokenCompletedTabs.push("Select Token");
                        return { ...pre };
                      });
                    });
                  }
                  if (deletearr.length > 0) {
                    deletearr.forEach((ele, index2) => {
                      console.log(ele);
                      if (
                        allTokens.filter((e) => {
                          return e.eventPrerequisiteName === ele.name;
                        }).length > 0
                      ) {
                        console.log("found");
                        setOpenPrerequisiteAlert(true);
                      } else {
                        deleteEventTokens(ele.eventTokenId).then((res) => {
                          if (index2 === deletearr.length - 1) {
                            setAllTokens((pre) => {
                              pre[
                                pre.findIndex(
                                  (e) => e.tokenId === element.tokenId
                                )
                              ].isSelected = false;
                              pre[
                                pre.findIndex(
                                  (e) => e.tokenId === element.tokenId
                                )
                              ].eventTokenId = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].eventPrerequisiteName = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].eventPrerequisiteId = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].isPrerequisite = false;
                              return [...pre];
                            });
                            setAllChildTokens((pre) => {
                              pre[
                                pre.findIndex(
                                  (e) => e.tokenId === element.tokenId
                                )
                              ].isSelected = false;
                              pre[
                                pre.findIndex(
                                  (e) => e.tokenId === element.tokenId
                                )
                              ].eventTokenId = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].eventPrerequisiteName = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].eventPrerequisiteId = null;
                              pre[
                                pre.findIndex((e) => e.tokenId === ele.tokenId)
                              ].isPrerequisite = false;
                              return [...pre];
                            });
                            setSelectTokens((pre) => {
                              pre.timeline[2].isSelected = true;
                              pre.timeline[1].isSelected = false;
                              return { ...pre };
                            });
                            successTost("Tokens saved successfully");
                            // let newarr = cloneDeep(allChildTokens)
                            // setAllTokens([...newarr])
                            setSearchToken("");
                            searchParams.set("submenu", "Select Prerequisite");
                            setSearchParams(searchParams);
                            dismissLoader();
                          }
                        });
                      }
                    });
                  } else {
                    setSelectTokens((pre) => {
                      pre.timeline[2].isSelected = true;
                      pre.timeline[1].isSelected = false;
                      return { ...pre };
                    });
                    successTost("Tokens saved successfully");
                    setSearchToken("");
                    searchParams.set("submenu", "Select Prerequisite");
                    setSearchParams(searchParams);
                    dismissLoader();
                    // let newarr = cloneDeep(allChildTokens)
                    // setAllTokens([...newarr])
                  }
                }
              });
            });
          } else if (deletearr.length > 0) {
            deletearr.forEach((ele, index2) => {
              if (
                allTokens.filter((e) => {
                  return e.eventPrerequisiteName === ele.name;
                }).length > 0
              ) {
                console.log("found");
                setOpenPrerequisiteAlert(true);
              } else {
                deleteEventTokens(ele.eventTokenId).then((res) => {
                  if (index2 === deletearr.length - 1) {
                    setAllTokens((pre) => {
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].isSelected = false;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventTokenId = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventPrerequisiteName = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventPrerequisiteId = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].isPrerequisite = false;
                      return [...pre];
                    });
                    setAllChildTokens((pre) => {
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].isSelected = false;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventTokenId = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventPrerequisiteName = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].eventPrerequisiteId = null;
                      pre[
                        pre.findIndex((e) => e.tokenId === ele.tokenId)
                      ].isPrerequisite = false;
                      return [...pre];
                    });
                    setSelectTokens((pre) => {
                      pre.timeline[2].isSelected = true;
                      pre.timeline[1].isSelected = false;
                      return { ...pre };
                    });
                    successTost("Tokens saved successfully");
                    setSearchToken("");
                    searchParams.set("submenu", "Select Prerequisite");
                    setSearchParams(searchParams);
                    dismissLoader();
                    // let newarr = cloneDeep(allChildTokens)
                    // setAllTokens([...newarr])
                  }
                });
              }
            });
          } else {
            successTost("Tokens saved successfully");
            setSelectTokens((pre) => {
              pre.timeline[2].isSelected = true;
              pre.timeline[1].isSelected = false;
              return { ...pre };
            });
            setSearchToken("");
            searchParams.set("submenu", "Select Prerequisite");
            setSearchParams(searchParams);
            dismissLoader();
            // let newarr = cloneDeep(allChildTokens)
            // setAllTokens([...newarr])
          }
        } else {
          arr.forEach((ele, index) => {
            insertEventTokens({ tokenId: ele.tokenId, eventId: eventId }).then(
              (resp) => {
                setAllTokens((pre) => {
                  pre[
                    pre.findIndex((e) => e.tokenId === ele.tokenId)
                  ].isSelected = true;
                  pre[
                    pre.findIndex((e) => e.tokenId === ele.tokenId)
                  ].eventTokenId = resp.data[0].eventTokenId;
                  return [...pre];
                });
                setAllChildTokens((pre) => {
                  pre[
                    pre.findIndex((e) => e.tokenId === ele.tokenId)
                  ].isSelected = true;
                  pre[
                    pre.findIndex((e) => e.tokenId === ele.tokenId)
                  ].eventTokenId = resp.data[0].eventTokenId;
                  return [...pre];
                });
                if (index === arr.length - 1) {
                  if (!event.tokenCompletedTabs.includes("Select Token")) {
                    let obj = cloneDeep(event);
                    obj.tokenCompletedTabs.push("Select Token");
                    if (isRepeated === true) {
                      obj.tokensRepeatedEventId =
                        repeatedEventId.repeatedEventId;
                      obj.isTokensRepeated = isRepeated;
                    }
                    updateEvent(eventId, obj).then((resp) => {
                      setEvent((pre) => {
                        pre.tokenCompletedTabs.push("Select Token");
                        return { ...pre };
                      });
                    });
                  }
                  setSelectTokens((pre) => {
                    pre.timeline[2].isSelected = true;
                    pre.timeline[1].isSelected = false;
                    return { ...pre };
                  });
                  successTost("Tokens saved successfully");
                  setSearchToken("");
                  searchParams.set("submenu", "Select Prerequisite");
                  setSearchParams(searchParams);
                  dismissLoader();
                  // let newarr = cloneDeep(allChildTokens)
                  // setAllTokens([...newarr])
                }
              }
            );
          });
        }
      }
    } else if (selectTokens.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Prerequisite') {
      if (showInventory) {
        // let allChildUnitsArr = []
        // Object.keys(allChildInventory).forEach((wing) => {
        //   Object.keys(allChildInventory[wing].floors).forEach((floor) => {
        //     allChildInventory[wing].floors[floor].units.forEach((unit) => {
        //       // if (unit.isSelected === true)
        //       allChildUnitsArr.push(unit)
        //     })
        //   })
        // })
        // console.log(allChildUnitsArr)
        // if (allChildUnitsArr.length > 0) {
        //   allChildUnitsArr.forEach((ele, index) => {
        //     let obj = {}
        //     if (ele.isSelected) {
        //       obj = { eventTokenId: selectedToken }
        //     } else {
        //       obj = { eventTokenId: null }
        //     }
        //     updateInventoryRelations(obj, ele.launchId, ele.unitId).then((resp) => {
        //       if (index === allChildUnitsArr.length - 1) {
        //         successTost("Inventory saved successfully")
        //         setShowInventory(false)
        //       }
        //     })
        //   })
        // } else {
        //   errorTost("Please select atleast one unit to proceed")
        // }
        let allUnitsArr = []
        let allChildUnitsArr = []
        Object.keys(allInventory).forEach((wing) => {
          Object.keys(allInventory[wing].floors).forEach((floor) => {
            allInventory[wing].floors[floor].units.forEach((unit) => {
              if (unit.isSelected === true) allUnitsArr.push(unit);
            });
          });
        });
        Object.keys(allChildInventory).forEach((wing) => {
          Object.keys(allChildInventory[wing].floors).forEach((floor) => {
            allChildInventory[wing].floors[floor].units.forEach((unit) => {
              if (unit.isSelected === true)
                allChildUnitsArr.push(unit)
            })
          })
        })
        if (allChildUnitsArr.length === 0) {
          let newarr = cloneDeep(allInventory)
          setAllChildInventory({ ...newarr })
          errorTost("Please select atleast one unit and then save")
          // searchParams.set('submenu', 'Select Inventory')
          // setSearchParams(searchParams)
          dismissLoader()
        } else {
          // if (!launch.completedTabs.includes('Select Inventory')) {
          //   setLaunch((pre) => { pre.completedTabs.push('Select Inventory'); return { ...pre } })
          // }
          let newarr = cloneDeep(allChildInventory)
          setAllInventory({ ...newarr })
          if (allChildUnitsArr.length > 0) {
            let deletearr = differenceWith(allUnitsArr, allChildUnitsArr, isEqual)
            let insertarr = differenceWith(allChildUnitsArr, allUnitsArr, isEqual)
            if (insertarr.length > 0) {
              insertarr.forEach((element, index) => {
                console.log(element)
                insertIntoPreselectInventoryRelations({ launchId: selectedLaunch, eventTokenId: selectedToken, unitId: element.unitId, wingId: element.wingId.wingId, mergeId: element.inventoryMergeId ? element.inventoryMergeId.inventoryMergeId : null }).then((resp) => {
                  // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = true; return [...pre] })
                  if (index === insertarr.length - 1) {
                    if (deletearr.length > 0) {
                      deletearr.forEach((ele, index2) => {
                        deleteInventoryRelationsOfPreselect(ele, selectedToken).then((res) => {
                          if (index2 === deletearr.length - 1) {
                            // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = false; return [...pre] })
                            successTost("Inventory saved successfully")
                            setShowInventory(false)
                            dismissLoader()
                            // setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                            // searchParams.set('submenu', 'Select Payment Plans')
                            // setSearchParams(searchParams)
                          }
                        })
                      })
                    } else {
                      successTost("Inventory saved successfully")
                      setShowInventory(false)
                      dismissLoader()
                      // setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                      // searchParams.set('submenu', 'Select Payment Plans')
                      // setSearchParams(searchParams)
                    }
                  }
                })
              })
            } else if (deletearr.length > 0) {
              deletearr.forEach((ele, index2) => {
                deleteInventoryRelationsOfPreselect(ele, selectedToken).then((res) => {
                  if (index2 === deletearr.length - 1) {
                    // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === ele.userId)].isSelected = false; return [...pre] });
                    successTost("Inventory saved successfully")
                    setShowInventory(false)
                    dismissLoader()
                    // setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                    // searchParams.set('submenu', 'Select Payment Plans')
                    // setSearchParams(searchParams)
                  }
                })
              })
            } else {
              successTost("Inventory saved successfully")
              setShowInventory(false)
              dismissLoader()
              // setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
              // searchParams.set('submenu', 'Select Payment Plans')
              // setSearchParams(searchParams)
            }
          }
        }
      } else if (showPPConfig) {
        if (!tokenForPP.startTimerFrom || tokenForPP.startTimerFrom === '' || !tokenForPP.startPaymentFrom || tokenForPP.startPaymentFrom === '' || !tokenForPP.expirePaymentOn || tokenForPP.expirePaymentOn === '' || !tokenForPP.limit || tokenForPP.limit === 0 || !tokenForPP.paymentTimer || tokenForPP.paymentTimer === 0) {
          errorTost('Please enter all dates & limit to conitnue')
        } else {
          presentLoader()
          supabase.from('EventTokens').update({ startDateTime: tokenForPP.startDateTime, endDateTime: tokenForPP.endDateTime, startTimerFrom: tokenForPP.startTimerFrom, startPaymentFrom: tokenForPP.startPaymentFrom, expirePaymentOn: tokenForPP.expirePaymentOn, limit: tokenForPP.limit, paymentTimer: tokenForPP.paymentTimer }).eq('eventTokenId', tokenForPP.eventTokenId).then((resp) => {
            setShowPPConfig(false)
            dismissLoader()
          })
        }
      } else {
        console.log(allChildTokens.filter((e) => { return e.isPrerequisite && !e.eventPrerequisiteName && e.isSelected === true }))
        if (allChildTokens.filter((e) => { return e.isPrerequisite && !e.eventPrerequisiteName && e.isSelected === true }).length > 0) {
          errorTost("Please select prerequisite token and then save")
          searchParams.set('submenu', 'Select Prerequisite')
          setSearchParams(searchParams)
        } else if (allChildTokens.filter((e) => { return e.isPriorityPass && e.eventTokenId && (!e.startTimerFrom || e.startTimerFrom === '' || !e.startPaymentFrom || e.startPaymentFrom === '' || !e.expirePaymentOn || e.expirePaymentOn === '') }).length > 0) {
          errorTost("Please set the dates for priority pass tokens and then save")
          searchParams.set('submenu', 'Select Prerequisite')
          setSearchParams(searchParams)
        } else {
          // let arr = allChildTokens.filter((e) => { return e.eventTokenId && e.eventPrerequisiteName && e.eventPrerequisiteName !== '' && e.isSelected === true })
          let arr = differenceWith(allChildTokens, allTokens, isEqual)
          console.log(arr)
          if (arr.length === 0) {
            // errorTost("Nothing To Save")
            // searchParams.set('submenu', 'Select Prerequisite')
            // setSearchParams(searchParams)
            setSelectTokens((pre) => { pre.timeline[2].isSelected = false; pre.timeline[3].isSelected = true; return { ...pre } })
            searchParams.set('submenu', 'Schedule Token')
            setSearchParams(searchParams)
          } else {
            presentLoader()
            arr.forEach((ele, index) => {
              updateEventTokens({ prerequisiteId: ele.eventPrerequisiteName ? allTokens[allTokens.findIndex((e) => e.name === ele.eventPrerequisiteName)].eventTokenId : null, eventTokenId: ele.eventTokenId }).then((resp) => {
                if (index === arr.length - 1) {
                  if (!event.tokenCompletedTabs.includes('Select Prerequisite')) {
                    let obj = cloneDeep(event)
                    obj.tokenCompletedTabs.push('Select Prerequisite')
                    if (isRepeated === true) {
                      obj.tokensRepeatedEventId = repeatedEventId.repeatedEventId
                      obj.isTokensRepeated = isRepeated
                    }
                    updateEvent(eventId, obj).then((resp) => {
                      setEvent((pre) => {
                        pre.tokenCompletedTabs.push('Select Prerequisite')
                        return { ...pre }
                      })
                    })
                  }
                  successTost("Prerequisite's saved successfully")
                  setSelectTokens((pre) => { pre.timeline[2].isSelected = false; pre.timeline[3].isSelected = true; return { ...pre } })
                  setSearchToken('')
                  let newarr = cloneDeep(allChildTokens)
                  setAllTokens([...newarr])
                  searchParams.set('submenu', 'Schedule Token')
                  setSearchParams(searchParams)
                  dismissLoader()
                }
              })
            })
          }
        }
      }
    } else if (selectTokens.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Schedule Token') {
      console.log(allChildTokens.filter((e) => { return (!e.startDateTime || !e.endDateTime) && e.eventTokenId }))
      if (allChildTokens.filter((e) => { return (!e.startDateTime || !e.endDateTime) && e.eventTokenId && e.isSelected === true }).length > 0) {
        errorTost("Please select dates and then save")
        searchParams.set('submenu', 'Schedule Token')
        setSearchParams(searchParams)
      } else {
        presentLoader()
        let arr = allChildTokens.filter((e) => { return e.eventTokenId })
        arr.forEach((ele, index) => {
          updateEventTokens({ startDateTime: new Date(ele.startDateTime).getTime(), endDateTime: new Date(ele.endDateTime).getTime(), eventTokenId: ele.eventTokenId }).then((resp) => {
            if (index === arr.length - 1) {
              if (!event.tokenCompletedTabs.includes('Schedule Token')) {
                let obj = cloneDeep(event)
                obj.tokenCompletedTabs.push('Schedule Token')
                if (isRepeated === true) {
                  obj.tokensRepeatedEventId = repeatedEventId.repeatedEventId
                  obj.isTokensRepeated = isRepeated
                }
                updateEvent(eventId, obj).then((resp) => {
                  setEvent((pre) => {
                    pre.tokenCompletedTabs.push('Schedule Token')
                    return { ...pre }
                  })
                })
              }
              successTost("Schedule saved successfully");
              setSelectTokens((pre) => {
                pre.timeline[3].isSelected = false;
                pre.timeline[4].isSelected = true;
                return { ...pre };
              });
              searchParams.set("submenu", "Tag Launch");
              setSearchParams(searchParams);
              setSearchToken("");
              let newarr = cloneDeep(allChildTokens);
              setAllTokens([...newarr]);
              dismissLoader();
              //navigate(`/home/Event/ConfigureEvent/${eventId}`)
            }
          })
        })
      }
    } else if (
      selectTokens.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Tag Launch"
    ) {
      presentLoader();
      await deleteTagLaunches(eventId).then(() => {
        allChildTokens
          .filter((e) => {
            return e.isSelected === true && e.show === true;
          })
          .map((m, index) => ({ ...m, index: index + 1 }))
          .map(async (value, index) => {
            if(value?.launches?.length > 0){
            value?.launches?.map(async (l) => {
              const payload = {
                eventId: eventId,
                eventTokenId: value?.eventTokenId,
                launchId: l?.launchId,
                userId: loggedInUser?.userId,
              };
                await insertTagLaunches(payload)
                  .then(() => {
                    if (
                      index ===
                      (allChildTokens
                        .filter((e) => {
                          return e.isSelected === true && e.show === true;
                        })
                        .map((m, index) => ({ ...m, index: index + 1 }))?.length -
                        1)
                    ) {
                      if (!event.tokenCompletedTabs.includes("Tag Launch")) {
                        let obj = cloneDeep(event);
                        obj.tokenCompletedTabs.push("Tag Launch");
                        updateEvent(eventId, obj).then((resp) => {
                          setEvent((pre) => {
                            pre.tokenCompletedTabs.push("Tag Launch");
                            return { ...pre };
                          });
                        });
                      }
                      dismissLoader();
                      searchParams.set("submenu", "Tag Launch");
                      setSearchParams(searchParams);
                      setSearchToken("");
                      successTost("Token tag with launch successfully!");
                      navigate(`/home/Event/ConfigureEvent/${eventId}`);
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    errorTost(err.message);
                  });
            });
          }else if (
            index ===
            (allChildTokens
              .filter((e) => {
                return e.isSelected === true && e.show === true;
              })
              .map((m, index) => ({ ...m, index: index + 1 }))?.length -
              1)
          ) {
            if (!event.tokenCompletedTabs.includes("Tag Launch")) {
              let obj = cloneDeep(event);
              obj.tokenCompletedTabs.push("Tag Launch");
              updateEvent(eventId, obj).then((resp) => {
                setEvent((pre) => {
                  pre.tokenCompletedTabs.push("Tag Launch");
                  return { ...pre };
                });
              });
            }
            dismissLoader();
            searchParams.set("submenu", "Tag Launch");
            setSearchParams(searchParams);
            setSearchToken("");
            successTost("Token tag with launch successfully!");
            navigate(`/home/Event/ConfigureEvent/${eventId}`);
          }
          });
        })
    }
  }

  function selectAll() {
    if (selectTokens.timeline[1].isSelected === true) {
      setAllChildTokens((pre) => {
        pre.forEach((ele, index) => {
          pre[index].isSelected = true;
        })
        return [...pre]
      })
    }
  }

  function deSelectAll() {
    if (selectTokens.timeline[1].isSelected === true) {
      setAllChildTokens((pre) => {
        pre.forEach((ele, index) => {
          pre[index].isSelected = false;
        })
        return [...pre]
      })
    }
  }

  return (
    <div className={cssClasses.container}>
      <div style={{ height: "calc(100% - 4rem)" }}>
        {/* <div className={cssClasses.header}>
          <div className={cssClasses.titleWrapper}>
            <div className={cssClasses.title}>
              <p>Select Tokens</p>
            </div>
            <div className={cssClasses.subtitle}>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
          </div>
          <div className={cssClasses.btn}>
            <Button
                clicked={() => {
                  localStorage.setItem("event", "");
                  navigate("/home/Event/AddEvent");
                }}
              btnName={"Publish"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#1570EF",
                color: "#FFFFFF",
                fontSize: "1.6rem",
              }}
              padding={"0.5rem 1rem"}
              iconPosition={"left"}
            />
          </div>
        </div> */}
        <div className={cssClasses.content}>
          <div className={cssClasses.progressCardWrapper}>
            <div className={cssClasses.progressCard}>
              <ProgressCard
                defaultExpanded={false}
                image={selectTokens.image}
                totalProgress={selectTokens.totalProgress}
                currentProgress={selectTokens.currentProgress}
                timeline={selectTokens.timeline}
                cardTitle={selectTokens.title}
              />
            </div>
          </div>
          {!showInventory && !showPPConfig &&
            <div className={cssClasses.tabsWrapper}>
              <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
                <TabContext
                  value={selectTokens.timeline.find((f) => f.isSelected).value}
                >
                  <TabsMenu
                    selectedColor={"#1570EF"}
                    selectedBackgroundColor={"#FFFFFF"}
                    stylesForTab={{
                      color: "#344054",
                      fontSize: "1.6rem",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "2.4rem",
                      padding: "0.8rem 1.2rem",
                      textTransform: "unset",
                      borderBottom: "1px solid #EAECF0",
                    }}
                    borderColor={"#1570EFs"}
                    stylesForWrapper={{
                      padding: "1.5rem 0",
                      background: "#FFFFFF",
                    }}
                    list={selectTokens.timeline}
                    value={selectTokens.timeline.find((f) => f.isSelected).value}
                    handleChange={(e, value) => {
                      // tabChanged(e, value);
                      searchParams.set('submenu', value)
                      setSearchParams(searchParams)
                    }}
                  />
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Repeated Launch"}
                    index={0}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <div style={{ maxWidth: "40rem" }}>
                        <div className={cssClasses.firstTabTitle}>
                          Is this a repeated Event?
                        </div>
                        <CustomRadio
                          optionList={optionList}
                          value={isRepeated ? "Yes" : "No"}
                          onChangeValue={handleChange}
                          gap="5rem"
                        />
                      </div>
                      {isRepeated &&
                        <div>
                          <p className={cssClasses.firstTabTitle}>Event Name: {event?.tokensRepeatedEventId?.title ? event?.tokensRepeatedEventId?.title : repeatedEventId?.repeatedEventName}</p>
                        </div>
                      }
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Select Token"}
                    index={1}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <div style={{ height: "calc(100% - 2rem)" }}>
                        <SelectToken
                          allChildRows={allChildTokens}
                          deSelectAll={deSelectAll}
                          selectAll={selectAll}
                          columns={selectTokenGridColumns}
                          setSearchToken={setSearchToken}
                          rows={allChildTokens.filter((e) => { return e.show === true })}
                        />
                      </div>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Select Prerequisite"}
                    index={2}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <div style={{ height: "calc(100% - 2rem)" }}>
                        <SelectPreRequisite
                          columns={selectPreRequisiteGridColumns}
                          rows={allChildTokens.filter((e) => { return e.isSelected === true && e.show === true }).map((m, index) => ({ ...m, index: index + 1 }))}
                          setSearchToken={setSearchToken}
                        // token={token}
                        />
                      </div>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Schedule Token"}
                    index={3}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <ScheduleToken
                        columns={scheduleTokenGridColumns}
                        rows={allChildTokens.filter((e) => { return e.isSelected === true && e.show === true }).map((m, index) => ({ ...m, index: index + 1 }))}
                        setSearchToken={setSearchToken}
                      // setToken={setToken}
                      // token={token}
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Tag Launch"}
                    index={4}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <TagLaunch
                        columns={TagLaunchColumn}
                        rows={allChildTokens
                          .filter((e) => {
                            return e.isSelected === true && e.show === true;
                          })
                          .map((m, index) => ({ ...m, index: index + 1 }))
                          // ?.map((v) => {
                          //   return {
                          //     ...v,
                          //     launches: allLaunches?.map(v => {
                          //       return {
                          //         ...v,
                          //         label: v?.title,
                          //         name: v?.title,
                          //         id:v?.launchId
                          //       }
                          //     })
                          //   };
                          // })
                          }
                        setSearchToken={setSearchToken}
                      />
                    </Box>
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
          }
          {showInventory &&
            <div className={cssClasses.tabsWrapper}>
              <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
                <TabContext
                  value={preselect.find((f) => f.isSelected).value}
                >
                  <TabsMenu
                    selectedColor={"#1570EF"}
                    selectedBackgroundColor={"#FFFFFF"}
                    stylesForTab={{
                      color: "#344054",
                      fontSize: "1.6rem",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "2.4rem",
                      padding: "0.8rem 1.2rem",
                      textTransform: "unset",
                      borderBottom: "1px solid #EAECF0",
                    }}
                    borderColor={"#1570EFs"}
                    stylesForWrapper={{
                      padding: "1.5rem 0",
                      background: "#FFFFFF",
                    }}
                    list={preselect}
                    value={preselect.find((f) => f.isSelected).value}
                    handleChange={(e, value) => {
                      console.log(preselect)
                      console.log(value)
                      // tabChanged(e, value);
                      setPreselect((pre) => {
                        if (value === 'Update Price') {
                          pre[1].isSelected = true
                          pre[0].isSelected = false
                        } else {
                          pre[1].isSelected = false
                          pre[0].isSelected = true
                        }
                        return [...pre]
                      })
                      // searchParams.set('submenu', value)
                      // setSearchParams(searchParams)
                    }}
                  />
                  <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Select Inventory"}
                    index={0}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <div>
                        <div style={{ display: "flex" }}>
                          <DropDown list={allLaunches.map((m) => m.title)} onChangeSelect={(launch) => { setAllChildInventory([]); setAllInventory([]); setSelectedProject(allLaunches.find((e) => e.title === launch).projectId.projectId); setSelectedLaunch(allLaunches.find((e) => e.title === launch).launchId) }} selectedValue={selectedLaunch ? allLaunches.find((e) => e.launchId === selectedLaunch).title : ''} placeHolder={"Select Launch"} />
                        </div>
                        <div>
                          {selectedLaunch && selectedLaunch !== '' &&
                            <SelectInventory setTotalFloorsSelected={setTotalFloorsSelected} setTotalUnitsSelected={setTotalUnitsSelected} selectedLaunch={selectedLaunch} totalFloorsSelected={totalFloorsSelected} totalUnitsSelected={totalUnitsSelected} showMergeBtn={false} unitsToMerge={unitsToMerge} allInventory={allInventory} setOpenAlert={setOpenAlert} allChildInventory={allChildInventory} mode={'edit'} setAllChildInventory={setAllChildInventory} />
                          }
                        </div>
                      </div>
                    </Box>
                  </TabPanel>
                  {/* <TabPanel
                    className={cssClasses.tabPanel}
                    value={"Update Price"}
                    index={1}
                  >
                    <Box className={cssClasses.mainTabPanelWrapper}>
                      <p>Update Price</p>
                    </Box>
                  </TabPanel> */}
                </TabContext>
              </Box>
            </div>
          }
          {showPPConfig &&
            <>
              <div style={{
                margin: '2rem',
                borderTop: '1px solid rgb(208, 213, 221)',
                padding: '2rem',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: '5rem'
              }}>
                <div>
                  <DateComponent helperText={''} value={tokenForPP.startTimerFrom}
                    onChangeDate={(e) => {
                      setAllChildTokens((pre) => {
                        console.log(pre);
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].startTimerFrom = new Date(e).getTime();
                        return [...pre];
                      });
                      setTokenForPP((pre) => {
                        pre.startTimerFrom = new Date(e).getTime();
                        return { ...pre };
                      });
                    }}
                    isMandatory={true} label={'Start Timer From'}></DateComponent>
                </div>
                <div>
                  <DateComponent helperText={''} value={tokenForPP.startPaymentFrom}
                    onChangeDate={(e) => {
                      setAllChildTokens((pre) => {
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].startPaymentFrom = new Date(e).getTime();
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].startDateTime = new Date(e).getTime();
                        return [...pre];
                      });
                      setTokenForPP((pre) => {
                        pre.startPaymentFrom = new Date(e).getTime();
                        pre.startDateTime = new Date(e).getTime();
                        return { ...pre };
                      });
                    }}
                    isMandatory={true} label={'Start Payment From'}></DateComponent>
                </div>
                <div>
                  <DateComponent helperText={''} value={tokenForPP.expirePaymentOn}
                    onChangeDate={(e) => {
                      setAllChildTokens((pre) => {
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].expirePaymentOn = new Date(e).getTime();
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].endDateTime = new Date(e).getTime();
                        return [...pre];
                      });
                      setTokenForPP((pre) => {
                        pre.expirePaymentOn = new Date(e).getTime();
                        pre.endDateTime = new Date(e).getTime();
                        return { ...pre };
                      });
                    }}
                    isMandatory={true} label={'Expire Payment On'}></DateComponent>
                </div>
              </div>
              <div style={{
                margin: '2rem',
                // borderTop: '1px solid rgb(208, 213, 221)',
                padding: '2rem',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: '5rem'
              }}>
                <div>
                  <CustomInput inputType="number" label="Limit" helperText={helperText.limit} value={tokenForPP.limit} placeholder={'Enter limit'} handleChange={(e) => {
                    if (e <= 0) {
                      setHelperText((pre) => { pre.limit = 'Limit must be greater than 0!'; return pre; })
                    } else {
                      setHelperText((pre) => { pre.limit = ''; return pre; })
                      setAllChildTokens((pre) => {
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].limit = e;
                        return [...pre];
                      });
                      setTokenForPP((pre) => {
                        pre.limit = e;
                        return { ...pre };
                      });
                    }
                  }} />
                </div>
                <div>
                  <CustomInput inputType="number" label="Payment Time (in minutes)" helperText={helperText.paymentTimer} value={tokenForPP.paymentTimer} placeholder={'Enter payment time in minutes'} handleChange={(e) => {
                    if (e <= 0) {
                      setHelperText((pre) => { pre.paymentTimer = 'Payment Time must be greater than 0!'; return pre; })
                    } else {
                      setHelperText((pre) => { pre.paymentTimer = ''; return pre; })
                      setAllChildTokens((pre) => {
                        pre[pre.findIndex((e) => e.eventTokenId === tokenForPP.eventTokenId)].paymentTimer = e;
                        return [...pre];
                      });
                      setTokenForPP((pre) => {
                        pre.paymentTimer = e;
                        return { ...pre };
                      });
                    }
                  }} />
                </div>
              </div>
            </>
          }
        </div>
      </div>
      <div className={cssClasses.footer}>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: "1.6rem" }}
        >
          {selectTokens.timeline[0].isSelected !== true && (
            <Button
              clicked={() => {
                if (showInventory) {
                  setShowInventory(false)
                } else if (showPPConfig) {
                  setShowPPConfig(false)
                } else {
                  setSelectTokens((pre) => {
                    let index = selectTokens.timeline.findIndex(
                      (e) => e.isSelected === true
                    );
                    pre.timeline[index].isSelected = false;
                    pre.timeline[index - 1].isSelected = true;
                    searchParams.set('submenu', selectTokens.timeline[index - 1].value)
                    setSearchParams(searchParams)
                    return { ...pre };
                  });
                }
                setSearchToken('');
                setTokenForPP(null)
              }}
              btnName={"Back Step"}
              style={{
                borderRadius: "0.4rem",
                // backgroundColor: "#D0D5DD",
                // color: "#FFFFFF",
                color: 'rgb(21, 112, 239)',
                backgroundColor: 'rgb(255, 255, 255)',
                border: '1px solid rgb(21, 112, 239)',
                fontSize: "1.6rem",
              }}
              padding={"0.5rem 1rem"}
              iconPosition={"left"}
            />
          )}
        </div>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: "1.6rem" }}
        >
          {selectTokens.timeline[0].isSelected !== true &&
            <Button
              clicked={nextStep}
              btnName={"Save & Next Step"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#1570EF",
                color: "#FFFFFF",
                fontSize: "1.6rem",
              }}
              padding={"0.5rem 1rem"}
              iconPosition={"left"}
            />
          }
        </div>
      </div>
      {openAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            ModalResp(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenAlert(false)}
          title={"Warning"}
          subTitle={"Unsaved Changes! Do you want to continue without saving"}
          open={openAlert}
        />
      )}
      {openEventAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            Overwrite(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenEventAlert(false)}
          title={"Warning"}
          subTitle={"Token Configuration Already Exists! Do you want you overwrite the config"}
          open={openEventAlert}
        />
      )}
      {openPrerequisiteAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            ChangeTab(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenPrerequisiteAlert(false)}
          title={"Warning"}
          subTitle={"One of the tokens to delete is a prerequisite of another token! Please remove the dependency to continue"}
          open={openPrerequisiteAlert}
        />
      )}
      {openModal &&
        <SelectRepeatedEvent setIsRepeated={setIsRepeated} copyConfig={copyConfig} repeatedEventId={repeatedEventId} openModal={openModal} setOpenModal={setOpenModal} setRepeatedEventId={setRepeatedEventId} />
      }
    </div>
  );
}

export default SelectTokens;

